"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateSearchUrl = void 0;
const buildSearchMfeUrl_1 = require("./buildSearchMfeUrl");
const buildFusionUrl_1 = require("./buildFusionUrl");
const hoseasonsSpecailAccommodationTypes = ['boat-holidays', 'boats'];
const normalizeParams = (params) => Object.entries(params)
    .filter(([, v]) => v || (typeof v === 'number' && v === 0))
    .reduce((acc, [key, value]) => {
    if (Array.isArray(value)) {
        if (value.length > 0) {
            acc[key] = value.join(',');
        }
        return acc;
    }
    acc[key] = value?.toString();
    return acc;
}, {});
const generateSearchUrl = (params, brand) => {
    const { accommodationType } = params;
    const searchParams = new URLSearchParams(normalizeParams(params));
    if (typeof accommodationType === 'string' &&
        hoseasonsSpecailAccommodationTypes.includes(accommodationType)) {
        return (0, buildFusionUrl_1.buildFusionUrl)(searchParams, brand);
    }
    return (0, buildSearchMfeUrl_1.buildSearchMfeUrl)(searchParams);
};
exports.generateSearchUrl = generateSearchUrl;
//# sourceMappingURL=generateSearchUrl.js.map